/* import popupsApi from "../../api/popups" */
import Vue from "vue"
import utilsApi from "../../api/utils"
const initialObject = {
  _id: undefined,
  name: undefined,
  background_color: undefined,
  delay: undefined,
  exclude_selection: undefined,
  save_state_to_local_storage: undefined,
  selected_events: undefined,
  selected_ref: undefined,
  slug: undefined,
  selected_records: undefined,
  opacity: undefined,
  body: undefined,
  status: undefined,
  createdAt: undefined,
  updatedAt: undefined,
  popup: undefined
}
// general state for the site
const initialState = {
  popups: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: []
}
const ignoreObjectsFields = ["createdAt", "updatedAt"]

const state = Object.assign({}, initialState)

const getters = {
  popups: (state) => state.popups,
  popupsIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  popupsError: (state) => state.error,
  popups_Object: (state) => state.object,
  popups_isNew: (state) => state.isNew,
  popups_selected: (state) => state.selected
}
const actions = {
  async DELETE_popups({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("popups", object)
    if (apiResponse != null) {
      //commit("POPUPS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_popups", state.page)
      return true
    } else {
      commit("POPUPS_ERROR")
      return false
    }
  },

  async DELETE_SELECTED_popups({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_popups", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_popups", {
        param: "selected",
        value: []
      })
      return true
    }
  },

  UPDATE_popupsState({ commit }, payload) {
    commit("SET_popups", payload)
    return true
  },

  async UPDATE_popups({ commit, dispatch, state }, object) {
    const filtered = Object.keys(object)
      .filter((key) => !ignoreObjectsFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = object[key]
        return obj
      }, {})
    let apiResponse = await utilsApi.updateObject("popups", filtered)
    if (apiResponse != null) {
      commit("POPUPS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_popups", state.page)
      return true
    } else {
      commit("POPUPS_ERROR")
      return false
    }
  },
  async CREATE_popups({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("popups", object)
    if (apiResponse != null) {
      commit("SET_popups", { param: "object", value: apiResponse.popup })
      dispatch("FETCH_PAGE_popups", state.page)
      return true
    } else {
      commit("POPUPS_ERROR")
      return false
    }
  },
  async FETCH_popups({ commit }) {
    let apiResponse = await utilsApi.getObjects("popups")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("POPUPS_SETTING", apiResponse)
      return true
    } else {
      commit("POPUPS_ERROR")
      return false
    }
  },

  async FETCH_PAGE_popups({ commit }, page) {
    let apiResponse = await utilsApi.getObjectsPage("popups", page)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("POPUPS_SETTING", { ...apiResponse, page })
      return true
    } else {
      commit("POPUPS_ERROR")
      return false
    }
  },

  /*   UPDATE_FIELD_popups({ commit }, payload) {
    if (payload.parent == null) {
      commit("SET_POPUP_FIELD", payload)
      return true
    } else {
      commit("SET_POPUP_CHILD_FIELD", payload)
      return true
    }
  }, */
  UPDATE_OBJECT_popups({ commit }, payload) {
    commit("SET_OBJECT_POPUP", payload)
    return true
  },

  CLEAN_OBJECT_popups({ commit }) {
    commit("SET_OBJECT_POPUP_INITIAL")
    return true
  },
  async CLEAN_STORE_popups({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_popups", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  },
  UPDATE_SELECTED_popups({ commit }, payload) {
    commit("SET_SELECTED_POPUPS", payload)
    return true
  }
}

const mutations = {
  POPUPS_SETTING: (state, { popups, count = false, page }) => {
    //console.log(state)
    state.count = count || state.popups.length
    state.page = page || state.page
    state.popups = popups
    state.fetched = true
    state.error = false
  },
  POPUPS_ERROR: (state) => {
    state.popups = null
    state.fetched = true
    state.error = false
  },

  SET_OBJECT_POPUP: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_OBJECT_POPUP_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_SELECTED_POPUPS: (state, selectedPopUps) => {
    state.selected = selectedPopUps
  },
  SET_popups: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
